import { createTheme } from '@mui/material/styles';
import { colors, typography, borderRadius, shadows, zIndex } from './tokens';

// Create light theme
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: colors.primary,
    secondary: colors.secondary,
    success: colors.success,
    error: colors.error,
    warning: colors.warning,
    info: colors.info,
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
    text: {
      primary: colors.neutral.gray900,
      secondary: colors.neutral.gray600,
      disabled: colors.neutral.gray400,
    },
    divider: colors.neutral.gray200,
  },
  typography: {
    ...typography,
  },
  shape: {
    borderRadius: borderRadius.md,
  },
  shadows: [
    'none',
    shadows.sm,
    shadows.md,
    shadows.md,
    shadows.md,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.xl,
    shadows.xl,
    shadows.xl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
  ],
  zIndex: {
    ...zIndex,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.md,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: shadows.md,
          },
        },
        contained: {
          '&:hover': {
            boxShadow: shadows.lg,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.lg,
          boxShadow: shadows.md,
          '&:hover': {
            boxShadow: shadows.lg,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.md,
        },
        elevation1: {
          boxShadow: shadows.sm,
        },
        elevation2: {
          boxShadow: shadows.md,
        },
        elevation3: {
          boxShadow: shadows.lg,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: borderRadius.md,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.sm,
          fontWeight: 500,
        },
      },
    },
  },
});

// Create dark theme
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: colors.primary,
    secondary: colors.secondary,
    success: colors.success,
    error: colors.error,
    warning: colors.warning,
    info: colors.info,
    background: {
      default: colors.background.dark,
      paper: colors.background.darkPaper,
    },
    text: {
      primary: colors.neutral.gray50,
      secondary: colors.neutral.gray400,
      disabled: colors.neutral.gray600,
    },
    divider: colors.neutral.gray700,
  },
  typography: {
    ...typography,
  },
  shape: {
    borderRadius: borderRadius.md,
  },
  shadows: [
    'none',
    shadows.sm,
    shadows.md,
    shadows.md,
    shadows.md,
    shadows.lg,
    shadows.lg,
    shadows.lg,
    shadows.xl,
    shadows.xl,
    shadows.xl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
    shadows.xxl,
  ],
  zIndex: {
    ...zIndex,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.md,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: shadows.md,
          },
        },
        contained: {
          '&:hover': {
            boxShadow: shadows.lg,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.lg,
          boxShadow: shadows.md,
          '&:hover': {
            boxShadow: shadows.lg,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.md,
        },
        elevation1: {
          boxShadow: shadows.sm,
        },
        elevation2: {
          boxShadow: shadows.md,
        },
        elevation3: {
          boxShadow: shadows.lg,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: borderRadius.md,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.sm,
          fontWeight: 500,
        },
      },
    },
  },
});

